import React, { Component } from "react";
import { withRouter } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import { pipe } from "../../../utilities/fp.js";
import Sidebar from "../../../_legacy/Containers/Settings/sidebar.js";
import Loader from "../../Common/Loader";
import { isFormSubmit } from "../../../Utils";
import {
  getShopifyData,
  shareIntegrationShopifyData,
} from "../../../Actions/Integrations/integrationActions.js";
import { exportEmptyData } from "../../../Actions/Appointment/appointmentAction.js";
import { uiNotification } from "../../../services/UINotificationService.js";
import { extractDomain } from "../../../utilities/general.js";
import { withAppTranslation } from "../../../i18n/useAppTranslation.js";

class Shopify extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showLoader: false,
      is_enabled: false,
      sync_products: false,
      shop_domain: "",
    };
  }

  getShopifyData = () => {
    this.props.getShopifyData().then((data) => {
      const syncData = data?.data || {};

      this.setState({
        showLoader: false,
        is_enabled: syncData.is_enabled === 1,
        sync_products: syncData.sync_products === 1,
        shop_domain: syncData.shop_domain,
        updated_at: syncData?.updated_at,
      });
    });
  };

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    this.setState({
      [event.target.name]: value,
    });

    if (
      target.type === "checkbox" &&
      value == false &&
      event.target.name === "is_enabled"
    ) {
      let formData = {
        is_enabled: 0,
        sync_products: this.state.sync_products === true ? 1 : 0,
        shop_domain: extractDomain(this.state.shop_domain),
      };

      this.setState({ showLoader: true });
      this.props
        .shareIntegrationShopifyData(formData)
        .then(() => {
          this.getShopifyData();
          uiNotification.success("Shopify integration disabled successfully");
        })
        .catch((error) => {
          uiNotification.error(
            this.props.tCommon([
              `integrations.shopify.apiError.${error.message}`,
              "error.fallback",
            ]),
          );
        })
        .finally(() => {
          this.setState({ showLoader: false });
        });
    }
  };

  handleSubmit = (event) => {
    if (isFormSubmit()) {
      event.preventDefault();
      const formData = {
        is_enabled: this.state.is_enabled === true ? 1 : 0,
        sync_products: this.state.sync_products === true ? 1 : 0,
        shop_domain: extractDomain(this.state.shop_domain),
      };

      this.setState({ showLoader: true });
      this.props
        .shareIntegrationShopifyData(formData)
        .then(() => {
          this.getShopifyData();
          uiNotification.success("Shopify settings updated successfully");
        })
        .catch((error) => {
          uiNotification.error(
            this.props.tCommon([
              `integrations.shopify.apiError.${error.message}`,
              "error.fallback",
            ]),
          );
        })
        .finally(() => {
          this.setState({ showLoader: false });
        });
    }
  };

  componentDidMount() {
    this.setState({ showLoader: true });
    this.getShopifyData();
  }

  static getDerivedStateFromProps(nextProps) {
    let returnState = {};

    if (nextProps.invokeRedirect) {
      nextProps.history.push("/settings/profile");
    }

    return returnState;
  }

  render() {
    return (
      <div id="content">
        <div className="container-fluid content setting-wrapper">
          <Sidebar />
          <div className="memberWalletOuter relative">
            <div className="setting-setion m-b-10">
              <div className="membership-title">
                Sync Shopify
                <div className="memberRightActions">
                  <span className="switch-text"></span>
                  <label className="setting-switch pull-right">
                    <input
                      type="checkbox"
                      name="is_enabled"
                      id="is_enabled"
                      checked={this.state.is_enabled}
                      onChange={this.handleInputChange}
                    />
                    <span className="setting-slider"></span>
                  </label>
                </div>
              </div>
            </div>
            <div className="row">
              {this.state.is_enabled === true && (
                <div className="col-sm-12">
                  <div className="setting-setion">
                    <div className="membershipSectionTitle">Sync Settings</div>
                    <div className="wallet-edit-block">
                      <div className="membershipSectionContent row">
                        {this.state.updated_at && (
                          <p className="AuthorizedSync p-l-20">
                            <i className="fa fa-check-circle" />
                            Authorized on{" "}
                            {moment(this.state.updated_at).format(
                              "MM/DD/YYYY hh:mm A",
                            )}
                          </p>
                        )}
                        <div className="col-xs-12">
                          <div className="newInputFileldOuter">
                            <div className="newInputLabel">
                              Shop url<span className="setting-require">*</span>
                            </div>
                            <div className="setting-input-outer">
                              <input
                                name="shop_domain"
                                type="text"
                                value={this.state.shop_domain}
                                onChange={this.handleInputChange}
                                autoComplete="off"
                                className="newInputField"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xs-12">
                          <div className="setting-custom-switch product-active pull-left m-t-10">
                            <label className="setting-switch pull-left no-margin">
                              <input
                                type="checkbox"
                                className="setting-custom-switch-input"
                                name="sync_products"
                                autoComplete="off"
                                checked={this.state.sync_products}
                                onChange={this.handleInputChange}
                              />
                              <span className="setting-slider"></span>
                            </label>
                            <span
                              id="membership_lable"
                              className="m-l-15 radioLabel"
                            >
                              Sync product stock
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="footer-static">
                        <button
                          className="new-blue-btn pull-right"
                          onClick={this.handleSubmit}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <Loader showLoader={this.state.showLoader} isFullWidth={true} />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  uiNotification.clear();
  const languageData = JSON.parse(localStorage.getItem("languageData"));
  const returnState = {};

  if (state.IntegrationReducer.data?.status === 402) {
    returnState.invokeRedirect = true;
  }

  if (state.IntegrationReducer.action === "GET_SHOPIFY_DATA") {
    if (
      state.IntegrationReducer.data?.status === 200 ||
      state.IntegrationReducer.data?.status === 201
    ) {
      returnState.syncData = state.IntegrationReducer.data.data;
      returnState.syncDataTime = new Date();
    } else {
      uiNotification.error(
        languageData.global[state.IntegrationReducer?.data?.message],
      );
    }
  }

  if (state.IntegrationReducer.action === "SHARE_SHOPIFY_DATA") {
    if (
      state.IntegrationReducer.data?.status === 200 ||
      state.IntegrationReducer.data?.status === 201
    ) {
      returnState.setSyncData = state.IntegrationReducer.data.data;
      returnState.setSyncDataTime = new Date();
      returnState.message =
        languageData.global[state.IntegrationReducer?.data?.message];
    }
  }

  return returnState;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      exportEmptyData: exportEmptyData,
      getShopifyData: getShopifyData,
      shareIntegrationShopifyData: shareIntegrationShopifyData,
    },
    dispatch,
  );
}

export default pipe(
  Shopify,
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  withAppTranslation("common"),
);
